import React from 'react';
import PropTypes from 'prop-types';

import { Cover, IconsWithText, Layout, Link, SectionTextMediaWrap, SEO, SectionHighlight, SectionThreeIcons, SectionReviewModals } from 'components';

import { routes } from 'utils/routes';
import { media } from "utils/media";
// Content
import contentSEO from "cms/content/how-it-work-seo.yml";
import contentCover from "cms/content/how-it-works-cover.yml";
import contentSecOne from "cms/content/how-it-works-section-one.yml";
import contentSecTwo from "cms/content/how-it-works-section-two.yml";
import contentSecThree from "cms/content/how-it-works-section-three.yml";
import contentSecFour from "cms/content/how-it-works-section-four.yml";
import contentSecFive from "cms/content/how-it-works-section-five.yml";
import contentSecSix from "cms/content/how-it-works-section-six.yml";
import contentSecSeven from "cms/content/how-it-works-section-seven.yml";
import contentIcons from "cms/content/how-it-works-icons-with-text.yml";
import contentHighlight from "cms/content/how-it-works-section-highlight.yml"
import contentThreeIcons from "cms/content/how-it-works-section-three-icons.yml"
import contentSecReviewModals from "cms/content/how-it-works-section-review-modals.yml"

const HowItWorksPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Link to={routes.apart.path} {...routes.apart} className='cta-sidetab'>What sets us apart?</Link>

    <Cover
      title={contentCover.title}
      text={contentCover.text}
      image={{ url: media(contentCover.image), alt: 'Invisible braces at home' }}
      overlap={contentCover.overlap}
      stamp={contentCover.stamp}
    />

    <IconsWithText content={contentIcons} />

    <h2 className='section-title mb-50 mt-50'>The process</h2>

    <SectionTextMediaWrap content={contentSecOne} locale={locale}/>
    <SectionTextMediaWrap content={contentSecTwo} locale={locale} />
    {locale === 'uk' &&
      <SectionTextMediaWrap content={contentSecThree} locale={locale} />
    }
    <SectionTextMediaWrap content={contentSecFour} locale={locale} />
    <SectionTextMediaWrap content={contentSecFive} locale={locale} />
    <SectionHighlight content={contentHighlight} />

    <SectionTextMediaWrap content={contentSecSix} locale={locale} />
    <SectionTextMediaWrap content={contentSecSeven} locale={locale}  buttonClass="outline" />

    <SectionThreeIcons content={contentThreeIcons} />
    <SectionReviewModals content={contentSecReviewModals} />

  </Layout>
);

HowItWorksPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default HowItWorksPage;
